import { render, staticRenderFns } from "./NodeDialog.vue?vue&type=template&id=56aa97e6&scoped=true&"
import script from "./NodeDialog.vue?vue&type=script&lang=js&"
export * from "./NodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./NodeDialog.vue?vue&type=style&index=0&id=56aa97e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa97e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDialog,VSpacer})
